import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  align-items: flex-start;
  padding: var(--card-padding);
  justify-content: space-between;
  font-size: 14px;
  color: var(--text-primary);
}

.center {
  flex: 1;
}

ef-avatar {
  margin-right: 8px;
}

a {
  font-weight: 600;
}

a:active {
  color: inherit;
}

ef-timeago {
  color: var(--text-secondary);
  font-size: 12px;
}

ef-timeago::before {
  content: '•';
  padding-right: 4px;
  font-size: 10px;
}

button {
  color: var(--link-primary);
  font-size: 12px;
  border: none;
  background-color: transparent;
  padding: 0;
}

button.reply::before {
  content: '';
  display: inline-block;
  height: 10px;
  width: 1px;
  margin-left: 4px;
  margin-right: 4px;
  background-color: var(--text-primary);
}

@media (hover: hover) {
  button:hover {
    color: var(--link-primary-hover);
  }
}

button:active {
  color: var(--info);
}

slot::slotted(p) {
  margin-top: 4px;
  margin-bottom: 4px;
}

slot::slotted(div) {
  height: 24px;
  width: 24px;
  font-size: 16px;
  text-align: center;
  line-height: 15px;
  background-color: white;
  color: var(--text-secondary);
  border: 1px solid var(--text-secondary);
  border-radius: 50%;
}

p.deleted {
  font-style: italic;
  margin-top: 4px;
  margin-bottom: 4px;
}
`;
export default styles;
